import * as theme from '../theme';

import styled from 'styled-components';
import equal_housing_lender_logo from '../assets/images/equal_housing_lender_logo.png';
import norton from '../assets/images/norton.png';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <Wrapper>
            <InnerWrapper>
                <Left>
                    <CopyRightTextContainer>
                        <CopyRightText>
                            All Rights Reserved. Copyright © 2007-{currentYear}{' '}
                            RateZip.com.
                        </CopyRightText>
                    </CopyRightTextContainer>
                </Left>
                <Right>
                    <HomeEqualLenderLogoContainer>
                        <HomeEqualLenderLogo
                            src={equal_housing_lender_logo}
                            alt={'equal_housing_lender_logo'}
                        />
                    </HomeEqualLenderLogoContainer>
                    <NortonLogoContainer>
                        <NortonLogo src={norton} alt={'norton'} />
                    </NortonLogoContainer>
                </Right>
            </InnerWrapper>
            <LegalTextContainer>
                <LegalText>
                    Peklava LLC, is a Duly Licensed Mortgage Broker and a
                    Marketing Lead Generator, as required by law, in{' '}
                    <a
                        href='https://www.ratezip.com/licenses-and-disclosures/'
                        target='_blank'
                        rel='noreferrer'
                    >
                        24 states
                    </a>
                    , with its main office located at 59 Grove Street, Unit 2J,
                    New Canaan, CT 06840, Peklava LLC, DBA RateZip NMLS ID
                    1592292.{' '}
                    <a
                        href='https://www.nmlsconsumeraccess.org/EntityDetails.aspx/COMPANY/1592292'
                        target='_blank'
                        rel='noreferrer'
                    >
                        NMLS Consumer Access
                    </a>
                    . This site is directed at, and made available to, persons
                    in the continental U.S, and Hawaii only.
                </LegalText>
            </LegalTextContainer>
            <FooterLinksContainer>
                <FooterLink href='http://www.ratezip.com/privacy-and-security/'>
                    Privacy and Security
                </FooterLink>
                <FooterLink href='https://www.links3.us/o-jpbp-g32-0854e572b59a3d6cae5e48ab0e4a6ed6'>
                    California Consumers: Do Not Sell or Share My Personal Information
                </FooterLink>
                <FooterLink href='/rate-quotes/flyreverse-2/notice-at-collection'>
                    Notice at Collection of Personal Information
                </FooterLink>
            </FooterLinksContainer>
        </Wrapper>
    );
};

const FooterLinksContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    margin: 1.5rem 0 80px 0;
`;

const FooterLink = styled.a`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 1rem;
    line-height: 20px;
    color: ${theme.primary};
    margin: 0 10px;
    text-decoration: none;

    &:hover {
        opacity: 1;
    }
`;

const Wrapper = styled.div`
    /* height: 68px; */
    background-color: ${theme.grey};
    width: 100%;
    display: flex;
    margin-top: 30px;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    @media (max-width: ${theme.mobile}) {
        position: block;
        bottom: 0px;
    }
`;

const InnerWrapper = styled(theme.section)`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 1rem 0;
    padding: 0;
    @media (max-width: ${theme.tablet}) {
        flex-direction: column-reverse;
        width: 95%;
        margin-top: 2rem;
    }
`;

const Left = styled.div``;

const CopyRightTextContainer = styled.div``;

const CopyRightText = styled.p`
    font-family: 'Inter';
    font-style: normal;
    font-weight: ${theme.font_weight};
    font-size: ${theme.font_size};
    line-height: 20px;

    @media (max-width: ${theme.mobile}) {
        text-align: center;
    }
`;

const Right = styled.div`
    display: flex;
    justify-content: space-around;
    align-items: center;
    gap: 2rem;

    @media (max-width: ${theme.mobile}) {
        width: 100%;
        justify-content: center;
        gap: 1rem;
    }
`;

const HomeEqualLenderLogoContainer = styled.div`
    width: 205px;
`;

const HomeEqualLenderLogo = styled.img`
    width: 100%;
`;

const NortonLogoContainer = styled.div`
    width: 80px;
`;

const NortonLogo = styled.img`
    width: 100%;
`;

const LegalTextContainer = styled(theme.section)`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 8px 0px 16px 0px;
    padding: 0px;
    @media (max-width: ${theme.mobile}) {
        flex-direction: column-reverse;
    }
`;

const LegalText = styled.p`
    font-family: Inter;
    font-style: normal;
    font-weight: 400;
    font-size: 1rem;
    line-height: 20px;
    color: rgb(0, 0, 0);
    opacity: 0.6;
    margin: 0px;
    > a {
        font-family: Inter;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
        color: rgb(0, 0, 0);
        opacity: 0.6;
        cursor: pointer;
    }

    @media (max-width: ${theme.mobile}) {
        font-size: 0.75rem;
        > a {
            font-size: 0.75rem;
        }
    }
`;

export default Footer;
